define('components/decorators/submit-get-on-change',[
    'jquery',
    '../util/reload-fragments'
],function($, reload ){

    $.extend(companyInfo.decorators,{

        'submit-get-on-change': function(){

            if ( !history && 'pushState' in history ) {
                return;
            }

            var el = $(this);
            var form = el.closest('form');
            var timeout;
            var type = el.data('reload-type');

            function submit(){
                var params = form.serialize();
                var url = [location.pathname,params].join('?');

                reload( type, url, function(){});
            }

            form.change(function(){
                clearTimeout(timeout);
                timeout = setTimeout(submit,800);
            });

        }

    });

});

